<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title
          primary-title
          style="background-color: rgba(227, 236, 238, 0.9)"
        >
          ลงชื่อเข้าใช้
          <v-spacer></v-spacer>
          <v-btn icon class="float-right" @click="close">
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-form ref="loginform" @submit.prevent="logIn()">
          <v-container class="px-8">
            <v-text-field
              dense
              class="mt-10"
              v-model="username"
              placeholder="ชื่อผู้ใช้"
              type="text"
              color="#4AA399"
              outlined
              :rules="rule_username"
              solo
            ></v-text-field>

            <v-text-field
              v-model="password"
              placeholder="รหัสผ่าน"
              type="password"
              outlined
              dense
              color="#4AA399"
              solo
              required
              :rules="rule_password"
            ></v-text-field>
            <v-row style="margin-top: -5%">
              <v-col cols="12">
                <a
                  class="pa-0 float-right"
                  type="submit"
                  style="text-decoration: underline"
                  @click="openDialogForgetPassword()"
                  text
                  outlined
                  >ลืมรหัสผ่าน ?</a
                ></v-col
              >
            </v-row>
            <v-card-actions class="pa-0">
              <v-row>
                <v-col cols="12">
                  <v-spacer></v-spacer>
                  <v-btn
                    class="pa-0 float-right"
                    style="background-color: #4aa399"
                    block
                    type="submit"
                    text
                    dark
                    outlined
                    >เข้าสู่ระบบ</v-btn
                  >
                </v-col>
                <v-col cols="12">
                  <v-row justify="center">
                    <!-- <div style="color:#464646;" class="text-center">
                      คุณมีบัญชีอยู่แล้วใช่หรือไม่?
                      <a
                        @click="$router.push('/register');
                        dialog=false"
                        style="color:#6aa7e0;"
                      >ลงทะเบียน</a>
                    </div>-->
                  </v-row>
                </v-col>
              </v-row>
              <!-- <v-btn
                    color="#4AA399"
                    class="pa-0"
                    text
                    style="text-decoration: underline;"
              >ลงทะเบียน</v-btn>-->
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <DialogForgetPassword ref="dialog_forget"></DialogForgetPassword>
  </div>
</template>
<script>
import DialogForgetPassword from "../components/DialogForgetPassword";
export default {
  components: {
    DialogForgetPassword,
  },
  data() {
    return {
      dialog: false,
      username: "",
      password: "",
      rule_password: [(v) => !!v || "กรุณากรอกรหัสผ่าน"],
      rule_username: [(v) => !!v || "กรุณากรอกชื่อผู้ใช้"],
    };
  },
  methods: {
    openDialogForgetPassword() {
      this.$refs.dialog_forget.openDialogForgetPassword();
    },
    open() {
      // console.log(this.$session.getAll());
      this.dialog = true;
      setTimeout(() => {
        this.$refs.loginform.reset();
        this.$refs.loginform.resetValidation();
      }, 200);
    },
    close() {
      this.dialog = false;
    },
    logIn() {
      // test
      // this.$session.set("token", "555");
      if (this.$refs.loginform.validate()) {
        // console.log(process.env.VUE_APP_API);
        let data = {
          username: this.username,
          password: this.password,
        };
        this.axios
          .post(process.env.VUE_APP_API + "/api/v1/login", data)
          .then((response) => {
            // console.log(response.data.lastname);

            if (response.data.message === "login success") {
              this.$session.set("token", response.data.access_token);
              this.$session.set("permission", response.data.permission);
              this.$session.set(
                "fullname",
                (response.data.firstname ? response.data.firstname : "") +
                  " " +
                  (response.data.lastname ? response.data.lastname : "")
              );
              // this.$session.set("permission", "admin");
              this.$swal.fire("เข้าสู่ระบบสำเร็จ", "OK", "success");

              let check_token = "";
              check_token = this.$session.get("token");
              check_token != "" ? this.$emit("show_login_btn", "token") : "";
              // console.log(this.$session.getAll());
              window.location.reload();

              this.close();
            } else if (
              response.data.message === "Does not exist this username"
            ) {
              this.$swal.fire("ชื่อผู้ใช้ไม่ถูกต้อง", " ", "error");
            } else if (response.data.message === "Unauthorization") {
              this.$swal.fire("รหัสผ่านไม่ถูกต้อง", " ", "error");
            }
          });
      } else {
        // console.log("invalid");
        // this.$swal.fire("InValiD DaTa", "WarnIng", "warning");
      }
    },
  },
};
</script>
